import { LegalDocView } from "@/components/marketing/LegalDocView";

export function PrivacyPolicy() {
  return (
    <LegalDocView
      kind="privacy_policy"
      eyebrow="Privacy"
      title="What we collect, why, and for how long."
    />
  );
}
